import { IUnderground, TTransportType } from '@cian/chats-api/lib/browser-entry';
import * as React from 'react';

import { TransportIcon } from '../transport_icon';
import { UndergroundIcon } from '../underground_icon';
import { WalkIcon } from '../walk_icon';

const style = require('./index.css');

interface IUndergroundProps {
  locationId?: number;
  underground: IUnderground;
}

const getIcon = (transportType: TTransportType) => (
  <span className={style['transport_type']}>{transportType === 'walk' ? <WalkIcon /> : <TransportIcon />}</span>
);

export const Underground: React.FunctionComponent<IUndergroundProps> = ({ locationId, underground }) => {
  return (
    <span className={style['underground']}>
      <span className={style['underground-ico']}>
        <UndergroundIcon width={12} height={12} color={`#${underground.lineColor}`} regionId={locationId} />
      </span>
      <span className={style['underground-header']}>{underground.name}</span>

      {underground.time > 0 ? (
        <span className={style['underground-distance']}>
          {getIcon(underground.transportType)}
          {underground.time}&nbsp;мин.&nbsp;
        </span>
      ) : (
        <span className={style['underground-distance']}>
          {getIcon(underground.transportType)}
          &lt;1 мин.&nbsp;
        </span>
      )}
    </span>
  );
};
